<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <ul
    :id="`reward-row-${rowIndex + numberOfECardRows}`"
    :key="rowIndex"
    class="container-brand-row d-flex flex-wrap"
  >
    <reward-card
      v-for="(brand, columnIndex) in brandRow"
      :id="`brand-reward-card-${brand.brandKey}`"
      :key="brand.brandKey"
      :use-new-reward-card="useNewRewardCard"
      :brand="brand"
      show-multi-utid-list
      sort-multiple-utids-by-denomination
      show-stock-indicator
      :low-stock-breakpoint="5"
      show-denomination
      :selected="selected"
      :column-index="columnIndex"
      :number-of-e-card-rows="numberOfECardRows"
      :row-index="rowIndex"
      @brand-clicked="brandClicked"
    />
    <transition
      @before-enter="beforeEnter"
      @enter="enter"
      @after-enter="afterEnter"
      @before-leave="beforeLeave"
      @leave="leave"
      @after-leave="afterLeave"
    >
      <v-container
        v-if="selected.brand && selected.row === rowIndex + numberOfECardRows"
        :id="`container-reward-details-${rowIndex + numberOfECardRows}`"
        fluid
        class="py-0 container-reward-details overflow-hidden"
        tag="li"
      >
        <reward-detail-view
          :brand="selected.brand"
          :triangle-position="selected.trianglePosition"
          :row="selected.row"
          :previous-amount="selected.previousAmount"
          :previous-utid="selected.previousUtid"
          :fulfillment-type="selected.fulfillmentType"
          @close="close"
        />
      </v-container>
    </transition>
  </ul>
</template>

<script>
import RewardDetailView from '@/components/reward/RewardDetailView'
import { RewardCard } from '@tangocard/mango'
import { mapGetters } from 'vuex'
import { GET_IS_LOCKED } from '@/store/get-types'
import { USE_NEW_REWARD_CARD } from '@/plugins/split/ActiveSplits'

export default {
  name: 'RewardCardRow',
  components: {
    RewardDetailView,
    RewardCard
  },
  props: {
    selected: {
      type: Object,
      required: false,
      default: () => {}
    },
    numberOfECardRows: {
      type: Number,
      required: false,
      default: 0
    },
    rowIndex: {
      type: [String, Number],
      required: false,
      default: 0
    },
    brandRow: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  computed: {
    ...mapGetters({
      isLocked: GET_IS_LOCKED
    }),
    useNewRewardCard () {
      return this.$isSplitEnabled(USE_NEW_REWARD_CARD)
    },
    brandClickDisabled () {
      return this.isLocked
    }
  },
  methods: {
    brandClicked (brand, row, trianglePosition) {
      if (this.brandClickDisabled) {
        return
      }
      this.$emit('brand-clicked', brand, row, trianglePosition)
    },
    beforeEnter (element) {
      this.$emit('before-enter', element)
    },
    enter (element) {
      this.$emit('enter', element)
    },
    afterEnter (element) {
      this.$emit('after-enter', element)
    },
    beforeLeave (element) {
      this.$emit('before-leave', element)
    },
    leave (element) {
      this.$emit('leave', element)
    },
    afterLeave (element) {
      this.$emit('after-leave', element)
    },
    close (event) {
      this.$emit('close', event)
    }
  }
}
</script>

<style lang="scss">
@import '../../../assets/css/variables';

ol {
  list-style-type: none;
}

.overflow-hidden {
  overflow: hidden;
}

.enter-reward-details,
.leave-reward-details {
  height: 0;
}

.show-reward-details {
  transition: height 0.8s ease-in;
}

.hide-reward-details {
  transition: height 0.8s ease-out;
  height: 0;
}

.overflow-hidden {
  overflow: hidden;
}

.container-reward-details {
  position: relative;
  top: -14px;

  &.v-enter {
    height: 0;
  }

  &.v-enter-active {
    transition: height 0.8s ease-in;
  }

  &.v-leave-active {
    transition: height 0.8s ease-out;
    height: 0;
  }

  .row {
    margin: 30px -7px 30px -7px;
    padding: 18px 0px 18px 18px;
    background-color: $tangoLtGray;
  }
}

@media screen and (max-width: $breakpoint-lg - 1) {
  .container-reward-details {
    .row {
      padding: 18px 18px 18px 18px;
    }
  }
}

@media screen and (max-width: $breakpoint-lg - 1) {
  .container-reward-details {
    #reward-triangle {
      &.pos1 {
        right: 82%;
      }

      &.pos2 {
        right: 47%;
      }

      &.pos3 {
        right: 13%;
      }
    }
  }
}
</style>
